// Presets por vertical para el Setup Wizard multi-vertical de Citame (NER-3254).
// Al seleccionar un vertical en el Paso 1, los pasos 2-4 se pre-cargan con estos
// defaults. El backend (POST /admin/setup-org, NER-3255) valida los mismos
// defaults. Spec fuente de verdad: whatsapp-scheduler/.agents/citame/product/
// setup-wizard-spec.md (revisado 2026-08-03 — medical removido, producto dedicado NER-3656).

export const VERTICAL_PRESETS = {
  padel: {
    label: 'Padel',
    icon: '🎾',
    industryKey: 'padel', // → METADATA.industry
    resourceType: 'cancha', // label UI dinámico (i18n setupWizard.resourceType.*)
    resourceCountDefault: 4,
    resourceNamesSuggested: ['Cancha 1', 'Cancha 2', 'Cancha Central', 'Cancha Techada'],
    slotDurationMinutes: 90,
    coverages: [
      { key: 'peak', name: 'Peak (Lun-Vie 18-23h + finde)', defaultPriceArs: 12000 },
      { key: 'off_peak', name: 'Off-peak (Lun-Vie 9-18h)', defaultPriceArs: 8000 },
      { key: 'abono', name: 'Abono mensual (opcional)', defaultPriceArs: null, optional: true },
    ],
    hoursDefault: { days: [1, 2, 3, 4, 5, 6, 0], openTime: '09:00', closeTime: '23:00' },
    templatesRequired: [
      'appointment_confirmation_padel',
      'appointment_reminder_padel_24h',
      'appointment_reminder_padel_2h',
    ],
    remindersDefault: [
      { hoursBefore: 24, templateName: 'appointment_reminder_padel_24h', enabled: true },
      { hoursBefore: 2, templateName: 'appointment_reminder_padel_2h', enabled: true },
    ],
  },

  estetica: {
    label: 'Estética',
    icon: '💅',
    industryKey: 'estetica',
    resourceType: 'esteticista',
    resourceCountDefault: 2,
    resourceNamesSuggested: ['Estilista 1', 'Estilista 2'],
    slotDurationMinutes: 60,
    coverages: [
      { key: 'servicio_basico', name: 'Servicio básico', defaultPriceArs: 8000 },
      { key: 'servicio_premium', name: 'Servicio premium', defaultPriceArs: 15000 },
    ],
    hoursDefault: { days: [2, 3, 4, 5, 6], openTime: '10:00', closeTime: '20:00' },
    templatesRequired: [
      'appointment_confirmation_estetica',
      'appointment_reminder_estetica_24h',
    ],
    remindersDefault: [
      { hoursBefore: 24, templateName: 'appointment_reminder_estetica_24h', enabled: true },
    ],
  },

  sports_generic: {
    label: 'Deportes (genérico)',
    icon: '🏟️',
    industryKey: 'sports',
    resourceType: 'espacio',
    resourceCountDefault: 2,
    resourceNamesSuggested: ['Espacio 1', 'Espacio 2'],
    slotDurationMinutes: 60,
    coverages: [
      { key: 'peak', name: 'Peak', defaultPriceArs: 10000 },
      { key: 'off_peak', name: 'Off-peak', defaultPriceArs: 6000 },
    ],
    hoursDefault: { days: [1, 2, 3, 4, 5, 6, 0], openTime: '08:00', closeTime: '22:00' },
    templatesRequired: [
      'appointment_confirmation_generic',
      'appointment_reminder_generic_24h',
    ],
    remindersDefault: [
      { hoursBefore: 24, templateName: 'appointment_reminder_generic_24h', enabled: true },
    ],
  },
};

export const VERTICAL_KEYS = Object.keys(VERTICAL_PRESETS);

// Templates aprobados por Meta (NER-3260: 7/7 approved, padel×3 + estetica×2 + generic×2).
// El estado real post-submit lo devuelve el backend (templatesApproved / templatesPending).
// Pre-submit se usa este set estático para preview en Paso 5.
export const APPROVED_TEMPLATES = new Set([
  'appointment_confirmation_padel',
  'appointment_reminder_padel_24h',
  'appointment_reminder_padel_2h',
  'appointment_confirmation_estetica',
  'appointment_reminder_estetica_24h',
  'appointment_confirmation_generic',
  'appointment_reminder_generic_24h',
]);

// Días de la semana en orden de UI (Lun→Dom). value = índice Cognito/backend
// (0=Domingo … 6=Sábado). labelKey → i18n setupWizard.days.*
export const WEEK_DAYS = [
  { value: 1, labelKey: 'mon' },
  { value: 2, labelKey: 'tue' },
  { value: 3, labelKey: 'wed' },
  { value: 4, labelKey: 'thu' },
  { value: 5, labelKey: 'fri' },
  { value: 6, labelKey: 'sat' },
  { value: 0, labelKey: 'sun' },
];

// Construye el wizardState inicial de los pasos 2-4 a partir del preset elegido.
export function presetToWizardState(verticalKey) {
  const preset = VERTICAL_PRESETS[verticalKey];
  if (!preset) return null;
  return {
    resources: preset.resourceNamesSuggested.map((name) => ({ name })),
    coverages: preset.coverages.map((c) => ({
      key: c.key,
      name: c.name,
      priceArs: c.defaultPriceArs,
      optional: !!c.optional,
    })),
    hours: {
      days: [...preset.hoursDefault.days],
      openTime: preset.hoursDefault.openTime,
      closeTime: preset.hoursDefault.closeTime,
      customPerDay: null,
    },
    settings: {
      slotDurationMinutes: preset.slotDurationMinutes,
      autoCompleteEnabled: true,
      noShowGracePeriodMin: 15,
    },
  };
}
